import { gql } from '@apollo/client';

export const SET_SHOP_ACCESS = gql`
    mutation SetShopAccess($shopAccess: Boolean!, $contact: String!) {
        setShopAccess(shopAccess: $shopAccess, contact: $contact)
    }
`;
